<template>
    <div>
        <div class='tools'>
          <b-btn @click="showStreetView" variant="map" :class="{'color-active':pressedstreetview}">
            StreetView
            <i class="fa fa-street-view" aria-hidden="true"></i>
            </b-btn>
          <br><br>
          <b-button @click="show = !show">
              <i class="fa fa-wrench"></i>
          </b-button>
            <ul class="toolbuttons mt-2" v-show="show">
              <li><b-btn @click="goToPosition" variant="map">Ir a posición actual</b-btn></li>
              <li><b-btn @click="showInfo" variant="map" :class="{'color-active':pressedinfo}">Info situación</b-btn></li>
              <li>
                <b-btn @click="distanceDraw" variant="map" :class="{'color-active':presseddist}" id="button-distance">
                  Medición
                  <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
                </b-btn>
              </li>
            </ul>
        </div>
        <div v-if="flag" class="info-modal">
            <template v-if="loading">
                <Loader></Loader>
            </template>
            <template v-else>
              <b-row>
                <b-col style="text-align: right;">
                  <b-button @click="cerrar">Cerrar</b-button>
                </b-col>
              </b-row>
                <br>
                <strong>Dirección: </strong>{{direccion}}<br>
                <strong>WGS84-4326 (Latitud/Y, Longitud/X): </strong>{{info.WGS84[1].toFixed(8)}}, {{info.WGS84[0].toFixed(8)}}<br> <!--TODO change Y,X for X,Y-->
                <strong>ETRS89-Z30N-25830 (X, Y): </strong>{{info['ETRS89-Z30N'][0].toFixed()}}, {{info['ETRS89-Z30N'][1].toFixed()}}<br>
                <!-- <strong>ED50-Z30N (23030): </strong>{{info['ED50-Z30N'][0].toFixed(2)}}, {{info['ED50-Z30N'][1].toFixed(2)}}<br> -->
                <strong>Zona: </strong> {{info.territorio}}<br>
                <strong>Provincia: </strong>{{info.provincia.name}} ({{info.provincia.code}})<br>
                <strong>Municipio: </strong>{{info.municipio.name}} ({{info.municipio.code}})<br>
                <strong :class="{'text-danger':info.esmunicipiodesplazado}">Municipio de Red Desplazada: </strong><strong v-if="info.esmunicipiodesplazado" class="text-danger">Sí</strong><span v-else>No</span><br>
                <strong>Código Postal: </strong>{{info.codigo_postal}}<br>
                <strong>Sección Censal: </strong>{{info.seccion}}<br>
                <strong>Zona exenta canon IRC: </strong>{{BoolParse(info.canon_irc)}}<br>
                <strong>Zona exenta derechos de Alta: </strong>{{BoolParse(info.derechos)}}<br>
                <strong>Distancia recta red Distribución En Servicio: </strong>
                <template v-if="!loading_distance">{{info2.dist_servicio}} m</template>
                <template v-else>Loading...</template><br>
                <strong>Distancia recta red Distribución No Abandonada: </strong>
                <template v-if="!loading_distance">{{info2.dist_otros}} m</template>
                <template v-else>Loading...</template><br>
                <strong>Distancia recta red Alta Presión En Servicio: </strong>
                <template v-if="!loading_distance">{{info2.trans_servicio}} m</template>
                <template v-else>Loading...</template><br>
                <strong>Distancia recta red Alta Presión No Abandonada: </strong>
                <template v-if="!loading_distance">{{info2.trans_otros}} m</template>
                <template v-else>Loading...</template><br>
            </template>
        </div>
    </div>
</template>

<style>
.tools{
  text-align: right;
  position: fixed;
  top: 30%;
  right: 0;
  z-index: 8;
}
.info-modal{
  padding: 1rem;
  right: 0;
  position: fixed;
  bottom: 0%;
  z-index: 9;
  background-color: white
}
.color-active{
  background-color: white !important;
  color: black!important;
}
.toolbuttons{
  list-style-type: none;
}
.toolbuttons  li{
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
export default {
  name: 'Tools',
  components: {
    Loader
  },
  data () {
    return {
      direccion: '',
      show: false,
      flag: false,
      info: null,
      info2: null,
      loading: false,
      loading_distance: false,
      pressedinfo: false,
      presseddist: false,
      pressedstreetview: false
    };
  },
  methods: {
    BoolParse: function (v) {
      if (v) {
        return 'Sí';
      } else {
        return 'No';
      }
    },
    goToPosition: function () {
      if ('geolocation' in navigator) {
        var th = this;
        navigator.geolocation.getCurrentPosition(function (position) {
          var bbox = [position.coords.latitude, position.coords.longitude];
          var latlng = {lat: position.coords.latitude, lng: position.coords.longitude};

          th.$parent.setView(bbox);
          th.$parent.setSearchMarker(latlng, 'Posición actual');
        });
      } else {
        alert('Navegador no compatible con esta funcionalidad.');
      }
    },
    cerrar: function () {
      this.flag = false;
      this.$emit('close');
    },
    showInfo: function () {
      this.pressedinfo = !this.pressedinfo;
      this.$emit('showInfo');
    },
    showStreetView: function () {
      this.pressedstreetview = !this.pressedstreetview;
      this.$emit('showStreet');
    },
    distanceDraw () {
      this.$emit('draw');
      this.presseddist = !this.presseddist;
      // if (this.presseddist) {
      //   this.$parent.map.distanceDrawer.enable()
      // }
    },
    getInfo: function (e) {
      this.flag = true;
      this.loading = true;
      this.loading_distance = true;
      this.$http.get('getInfo/', {params: {lat: e.latlng.lat, lng: e.latlng.lng}}).then(result => {
        this.info = result.data;
        this.loading = false;
      });
      this.$http.get('getDistance/', {params: {lat: e.latlng.lat, lng: e.latlng.lng}}).then(result => {
        this.info2 = result.data;
        this.loading_distance = false;
      });
      var th = this;
      self.$.ajax({
        url: 'https://maps.googleapis.com/maps/api/geocode/json',
        data: {key: process.env.GOOGLE_MAPS_API_KEY, latlng: e.latlng.lat + ',' + e.latlng.lng, language: 'es'}
      }).done(function (response) {
        if (response.results.length > 0) {
          th.direccion = response.results[0].formatted_address;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Tools.vue